<template>
    <div class="px-2">
        <div class="w-100 darker font-weight-600 mb-4 mt-2 mx-3 fs-large" v-if="transportExtrasArray.length > 0">Transport</div>

        <div v-if="transportsAlredyBooked.length === 0">
            <div v-for="(transport, index) in transportExtrasArray" :key="index" >
                <div class="pb-4">
                    <div class="d-flex flex-row justify-content-between bg-lighter py-1">
                        <div class="d-flex flex-column">
                            <div class="py-1 mx-3 d-flex flex-row justify-content-between">
                                <div>
                                    <p class="darker font-weight-600 pl-3 fs-normal">{{transport.component.name}} - {{transport.componentPrice.name}}</p>
                                </div>
                            </div>

                            <div class="pl-3 d-flex flex-row align-items-center pb-1">
                                <div class="d-flex flex-column min-size">
                                    <p class="dark font-weight-600 pl-3 fs-small">Availability: {{ showAvailability(transport) }}</p>
                                    <p class="dark font-weight-600 pl-3 fs-small">Price per pax: {{ formatPrice(transport.componentPrice.grossprice) }} €</p>
                                    <p class="dark font-weight-600 pl-3 fs-small">Total Price: {{ formatPrice(transport.quantityToAdd * transport.componentPrice.value) }} €</p>
                                </div>

                                <div class="d-flex flex-row ml-5 justify-content-center" v-if="(transport.quantityAvailable > 0 && transport.quantity > 0) || transport.quantity === 0">
                                    <button :class="[transport.quantityToAdd === 0 ? 'bg-medium' : '', 'btn', 'secondary']" @click="toggleButton(index, transport, true)">Yes</button>
                                    <button :class="[transport.quantityToAdd > 0 ? 'bg-medium' : '', 'btn', 'secondary', 'ml-2']" @click="toggleButton(index, transport, false)">No</button>
                                </div>

                                <div class="availability-info mx-3 mb-2 font-weight-600" v-else>
                                    <p>No more available seats</p>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex flex-column justify-content-center mr-3">
                            <div class="d-flex flex-row align-items-end max-content" v-if="transport.quantityToAdd !== 0 && transport.quantityToAdd < calculateTotalPax">
                                <i class="ico ico-alert color-6 mr-0 fs-super"></i>
                                <p class="color-6 fs-normal font-weight-600 ml-2">Pax without transport: <span class="fs-large font-weight-600">{{ calculateTotalPax - transport.quantityToAdd }}</span></p>
                            </div>

                            <div class="d-flex flex-column align-items-center mt-2 justify-content-center" v-if="transport.quantityToAdd > 0">
                                <div class="d-flex flex-row py-2 justify-content-center size">
                                    <span class="border-light py-1 px-2 radius-normal mx-2 text-center pointer" @click="changeExtraQtd('remove', transport)"><i class="ico ico-minus dark fs-smaller m-0"></i></span>
                                    <input disabled type="number" placeholder="0" min="0" class="text-center fs-larger px-0 bg-lighter darker input-size" v-model="transport.quantityToAdd">
                                    <span class="border-light py-1 px-2 radius-normal mx-2 text-center pointer" @click="changeExtraQtd('add', transport)"><i class="ico ico-add dark fs-smaller m-0"></i></span>
                                </div>

                                <div class="d-flex flex-row">
                                    <div class="max-content">
                                        <label class="dark font-weight-600 fs-small">Total pax with transport: </label>
                                        <span class="fs-large font-weight-600 ml-1">{{ transport.quantityToAdd }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>   
                </div>
            </div>
        </div>

        <div v-else class="mx-3 mb-2 font-weight-600">
            <div v-for="(transport, index) in transportsAlredyBooked" :key="index" > 
                <div class="pb-4">
                    <div class="d-flex flex-row justify-content-between bg-lighter py-1">
                        <div class="d-flex flex-column">
                            <div class="py-1 mx-3 d-flex flex-row justify-content-between">
                                <div>
                                    <p class="darker font-weight-600 pl-3 fs-normal">{{transport.component.name}} - {{transport.componentPrice.name}}</p>
                                </div>
                            </div>

                            <div class="pl-3 d-flex flex-row align-items-center pb-1 justify-content-between">
                                <div class="d-flex flex-column min-size">
                                    <p class="dark font-weight-600 pl-3 fs-small">Total Pax: {{ transport.quantity }}</p>
                                    <p class="dark font-weight-600 pl-3 fs-small">Price per pax: {{ formatPrice(transport.componentPrice.grossprice) }} €</p>
                                    <p class="dark font-weight-600 pl-3 fs-small">Total Price: {{ formatPrice(transport.quantity * transport.componentPrice.value) }} €</p>
                                </div>

                                <div class="availability-info mx-5 mb-2 font-weight-600" >
                                    <p>Transport already added</p>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex align-items-center mx-5">
                            <button class="btn secondary avoid-text-breaking" @click="changeToEdit">Edit Transport</button>
                        </div>
                    </div>   
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';

    export default {
        data() {
            return {
                transportExtrasArray: [],
                transportsAlredyBooked: [],
                updatedBtnTransfersFlag: false,
            }
        },
        props: {
            reservation: {
                type: Object
            }
        },
        created() {
            // Filter to get only components type 1 (transports)
            this.transportExtrasArray = this.reservation.event.eventComponents.filter((event) => event.component.componentType === 1);
            // Filter transport already booked
            this.transportsAlredyBooked = this.reservation.bookingComponents.filter((book) => book.quantity > 0 && book.component.componentType === 1);

            this.transportExtrasArray.map(extra => {
                if(!extra.quantityToAdd){
                    this.$set(extra, 'quantityToAdd', 0);
                }
            })     
        },
        computed: {
            calculateTotalPax() {
                return this.reservation.bookingGenderPrices.reduce((acc, comp) => {
                    return acc += comp.quantityToBook;
                }, 0)
            },
        },
        methods: {
            ...mapActions([
                'setReservationCalculations'
            ]),
            changeToEdit() {
                this.eventHub.$emit('editReservation_toggleViewExtas', 'addExtraTransport');
            },
            toggleButton(index, transport, value) {
                const totalPax = this.calculateTotalPax;

                // Validation to avoid extra unnecessary api calls
                if (!(value && transport.quantityToAdd > 0 || !value && transport.quantityToAdd === 0) && totalPax > 0) {
                    // Enable 1 btn and Disable others
                    this.transportExtrasArray.forEach((item, idx) => {
                        if (idx !== index) {
                            item.quantityToAdd = 0;
                            if (item.quantity !== 0 && item.quantityBooked !== item.quantity) {
                                item.quantityAvailable = item.quantity - item.quantityBooked;
                            }
                        }
                    });

                    // Update transports in bookingComponents
                    this.updateTransportState(transport, value);
                } else if (totalPax === 0 && value) {
                    this.$toasted.info('Please add pax at the reservation first!', { duration: 5000 });
                }
            },
            updateTransportState(transport, value) {
                const totalPax = this.calculateTotalPax;
                const quantityAvailable = transport.quantityAvailable;
                const updatedBtnTransfersFlag = this.updatedBtnTransfersFlag;

                // Validate if transport space is unlimited or there is X seats
                const hasLimitedSeats = transport.quantity !== 0;

                // Calculates the number of passengers to be added
                const addedPassengers = Math.min(totalPax, quantityAvailable);

                // Updates transport quantity and availabilty
                transport.quantityToAdd = value ? (hasLimitedSeats ? addedPassengers : totalPax) : 0;
                transport.quantityAvailable = value ? (hasLimitedSeats ? quantityAvailable - addedPassengers : 0) : transport.quantity;

                // Update transfers list
                if (transport.quantityToAdd !== 0 && !updatedBtnTransfersFlag) {
                    this.updatedBtnTransfersFlag = true;
                    this.updateTransfersList();
                } else if (!value){
                    this.updatedBtnTransfersFlag = false;
                    this.updateTransfersList();
                }

                // Update reservation calculation
                this.updateReservationCalculations();
            },
            changeExtraQtd(value, transport) {
                const totalPax = this.calculateTotalPax;
                const maxPersonsForTransport = transport.quantityToAdd === totalPax;
                const personsWithoutTransport = transport.quantityToAdd < totalPax;
                
                if (value === 'add') {
                    // Only increments if seats are unlimited or if has costumers without transport and seats available
                    if (transport.quantity === 0 && personsWithoutTransport
                            || transport.quantityAvailable > 0 && transport.quantityToAdd < transport.quantity && personsWithoutTransport) {
                        
                        transport.quantityToAdd++;
                        if (transport.quantity !== 0) transport.quantityAvailable--;
                        // If there is quantity to add add transfer list
                        if (transport.quantityToAdd === 1) this.updateTransfersList();
                    } else if (maxPersonsForTransport){
                        // If all costumers have transport, display informative message
                        this.$toasted.success('All pax with transport!', { duration: 5000 });
                    } else {
                        // If all seats are occupied, display informative message
                    this.$toasted.error('No more seats available!', { duration: 5000 });
                    }
                } else if (value === 'remove') {
                    if (transport.quantityToAdd > 0 && transport.quantityAvailable >= 0) {
                        transport.quantityToAdd--;
                        if (transport.quantity !== 0) transport.quantityAvailable++;
                        // If there is no quantity to add remove transfer list
                        if (transport.quantityToAdd === 0) {
                            this.updatedBtnTransfersFlag = false;
                            this.updateTransfersList();
                        } 
                    }
                }
                
                // Update reservation calculation
                this.updateReservationCalculations()
            },
            showAvailability(transport) {
                if (transport.quantity === 0) {
                    return 'unlimited';
                } else {
                    return transport.quantityAvailable;
                }
            },
            updateTransfersList() {
                const hasTransportAdded = this.transportExtrasArray.some((item) => item.quantityToAdd > 0);
                const updatedBtnTransfersFlag = this.updatedBtnTransfersFlag;

                if (hasTransportAdded && updatedBtnTransfersFlag) {
                    // Emitir para os botões serem selecionados ao escolher um transporte
                    this.eventHub.$emit('routeForm_updateTransportTransfer', true);
                } else if (!hasTransportAdded && !updatedBtnTransfersFlag) {
                    this.eventHub.$emit('routeForm_updateTransportTransfer', false);
                } 
            },
            updateReservationCalculations() {
                this.setReservationCalculations(this.reservation);
            }
        },
    }
</script>

<style lang="scss" scoped>
    .min-size {
        min-width: 150px;
    }

    .max-content {
        min-width: max-content;
    }

    .size {
        height: 46px;
    }

    .input-size {
        width: 1.8rem;
    }

    .availability-info {
        border: solid 1px #f16c64;
        border-radius: 25px;
        padding: 10px;
        color: #f16c64;
    }

    .avoid-text-breaking {
        white-space: nowrap;
    }
</style>



// WEBPACK FOOTER //
// AddExtraTransport.vue?95002660